import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const pt = localStorage.getItem("lostdc_token");
  const at = localStorage.getItem("lostdc_admin_token");
  if (config.url?.startsWith("/admin") || config.url?.startsWith("/auth/admin")) {
    if (at) config.headers.Authorization = `Bearer ${at}`;
  } else if (pt) {
    config.headers.Authorization = `Bearer ${pt}`;
  }
  return config;
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}

export function getVisitorId() {
  let v = localStorage.getItem("lostdc_vid");
  if (!v) {
    v = `v_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    localStorage.setItem("lostdc_vid", v);
  }
  return v;
}

export function trackPage(path) {
  api.post("/public/track", {
    path,
    referrer: document.referrer || "",
    visitor_id: getVisitorId(),
    screen: `${window.innerWidth}x${window.innerHeight}`,
  }).catch(() => {});
}
